import { render } from "./Recipe2Screen.vue?vue&type=template&id=26f919fc&scoped=true"
const script = {}

import "./Recipe2Screen.vue?vue&type=style&index=0&id=26f919fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f919fc"]])

export default __exports__